var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"show-answer",style:(_vm.getMargin)},_vm._l((_vm.answers),function(answer){return _c('div',{staticClass:"answer"},[_c('span',{class:_vm.getIconClass(answer.answer)}),_vm._v(" "+_vm._s(answer.percentage)+"\n  ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }